import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  menuBar: {
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    padding: 15,
    cursor: 'pointer',
    marginBottom: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > p': {
      color: `${theme.palette.primary.main}`,
    },
    '&.lastItem': {
      borderBottom: 'none',
    },
  },
  content: {
    padding: 15,
    paddingBottom: 0,
    '& table tr': {
      '& td': {
        paddingTop: 5,
        paddingBottom: 5,
      },
      '& td:first-child': {
        width: '30%',
        paddingLeft: 0,
        '& p': {
          color:
            theme.palette.type === 'dark'
              ? theme.palette.hover4
              : theme.palette.text.primary,
        },
      },
      '& td:last-child': {
        width: '70%',
        paddingRight: 0,
      },

      '& .subcontent': {
        display: 'flex',
        alignItems: 'start',

        '& > p': {
          flexGrow: 1,
          alignSelf: 'center',
          overflowWrap: 'anywhere',
          wordBreak: 'break-all',
        },
      },
      '& .copyIcon': {
        paddingLeft: 15,

        '& svg': {
          color: theme.palette.primary.main,
          fontSize: 14,
          margin: 3,
        },
      },
    },
  },
  arrowContent: {
    display: 'flex',
    alignItems: 'center',

    '& *': {
      marginLeft: 10,
      color: theme.palette.primary.main,
    },
  },
  emptySpace: {
    textAlign: 'center',
    marginBottom: 20,
  },
}))

export default useStyles
